export const SEO_CONFIG = {
  SITE_URL: 'https://localally.in',
  DEFAULT_OG_IMAGE: 'https://localally.in/og-image.jpg',
  CONTACT: {
    PHONE: '+91-XXXXXXXXXX',
    EMAIL: 'support@localally.in',
  },
  SOCIAL: {
    FACEBOOK: 'https://www.facebook.com/yourpage',
    INSTAGRAM: 'https://www.instagram.com/yourhandle',
    LINKEDIN: 'https://www.linkedin.com/company/yourcompany',
  },
  ADDRESS: {
    LOCALITY: 'Hyderabad',
    REGION: 'Telangana',
    COUNTRY: 'IN',
  },
  SERVICES: {
    HOME_TUITIONS: 'Home Tuitions',
    GROUP_TUITIONS: 'Group Tuitions', 
    TUITION_CENTERS: 'Tuition Centers',
    DANCE_CLASSES: 'Dance Classes',
    MUSIC_CLASSES: 'Music Classes',
    CARE_TAKER: 'Child Care Services',
    SCHOOL_UPDATES: 'School Updates & Events',
    GRAND_TESTS: 'Grand Tests & Exams',
    ANNUAL_FUNCTIONS: 'Annual Functions',
    HIRING: 'Educational Hiring',
    BOOKS_STATIONERY: 'Books & Stationery',
    SPORTS_CONNECT: 'Sports Teams, Tournaments & Grounds',
    RIDES: 'Local Rides, Auto Stands & Drivers',
    SAFETY_SOS: 'Safety SOS',
  },
};

export const HOMEPAGE_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'EducationalOrganization',
  name: 'LocalAlly.in',
  url: SEO_CONFIG.SITE_URL,
  logo: `${SEO_CONFIG.SITE_URL}/logo.png`,
  image: SEO_CONFIG.DEFAULT_OG_IMAGE,
  description:
    'LocalAlly.in is a local discovery platform serving Andhra Pradesh and Telangana, connecting people with tutors, coaching, books and stationery, sports teams, tournaments, grounds, local rides, auto stands, jobs, safety support and community updates.',
  telephone: SEO_CONFIG.CONTACT.PHONE,
  email: SEO_CONFIG.CONTACT.EMAIL,
  address: {
    '@type': 'PostalAddress',
    addressLocality: SEO_CONFIG.ADDRESS.LOCALITY,
    addressRegion: SEO_CONFIG.ADDRESS.REGION,
    addressCountry: SEO_CONFIG.ADDRESS.COUNTRY,
  },
  areaServed: [
    // Telangana Cities
    { '@type': 'City', name: 'Hyderabad' },
    { '@type': 'City', name: 'Secunderabad' },
    { '@type': 'City', name: 'Warangal' },
    { '@type': 'City', name: 'Nizamabad' },
    { '@type': 'City', name: 'Karimnagar' },
    { '@type': 'City', name: 'Khammam' },
    { '@type': 'City', name: 'Ramagundam' },
    { '@type': 'City', name: 'Mahbubnagar' },
    { '@type': 'City', name: 'Nalgonda' },
    { '@type': 'City', name: 'Siddipet' },
    { '@type': 'City', name: 'Adilabad' },
    { '@type': 'City', name: 'Miryalaguda' },
    { '@type': 'City', name: 'Suryapet' },
    { '@type': 'City', name: 'Jagtial' },
    { '@type': 'City', name: 'Kukatpally' },
    { '@type': 'City', name: 'Miyapur' },
    { '@type': 'City', name: 'Ameerpet' },
    { '@type': 'City', name: 'Madhapur' },
    { '@type': 'City', name: 'Gachibowli' },
    { '@type': 'City', name: 'Banjara Hills' },
    { '@type': 'City', name: 'Jubilee Hills' },
    // Andhra Pradesh Cities
    { '@type': 'City', name: 'Visakhapatnam' },
    { '@type': 'City', name: 'Vijayawada' },
    { '@type': 'City', name: 'Guntur' },
    { '@type': 'City', name: 'Nellore' },
    { '@type': 'City', name: 'Kurnool' },
    { '@type': 'City', name: 'Rajahmundry' },
    { '@type': 'City', name: 'Tirupati' },
    { '@type': 'City', name: 'Kakinada' },
    { '@type': 'City', name: 'Anantapur' },
    { '@type': 'City', name: 'Eluru' },
    { '@type': 'City', name: 'Vizianagaram' },
    { '@type': 'City', name: 'Ongole' },
    { '@type': 'City', name: 'Nandyal' },
    { '@type': 'City', name: 'Machilipatnam' },
    { '@type': 'City', name: 'Proddatur' },
    { '@type': 'City', name: 'Chittoor' },
    { '@type': 'City', name: 'Hindupur' },
    { '@type': 'City', name: 'Bhimavaram' },
    { '@type': 'City', name: 'Madanapalle' },
    { '@type': 'City', name: 'Guntakal' },
    { '@type': 'City', name: 'Tadepalligudem' },
    { '@type': 'City', name: 'Kadapa' },
  ],
  sameAs: Object.values(SEO_CONFIG.SOCIAL),
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'LocalAlly Local Services',
    itemListElement: [
      { '@type': 'Offer', name: SEO_CONFIG.SERVICES.HOME_TUITIONS },
      { '@type': 'Offer', name: SEO_CONFIG.SERVICES.GROUP_TUITIONS },
      { '@type': 'Offer', name: SEO_CONFIG.SERVICES.TUITION_CENTERS },
      { '@type': 'Offer', name: SEO_CONFIG.SERVICES.DANCE_CLASSES },
      { '@type': 'Offer', name: SEO_CONFIG.SERVICES.MUSIC_CLASSES },
      { '@type': 'Offer', name: SEO_CONFIG.SERVICES.CARE_TAKER },
      { '@type': 'Offer', name: SEO_CONFIG.SERVICES.SCHOOL_UPDATES },
      { '@type': 'Offer', name: SEO_CONFIG.SERVICES.GRAND_TESTS },
      { '@type': 'Offer', name: SEO_CONFIG.SERVICES.ANNUAL_FUNCTIONS },
      { '@type': 'Offer', name: SEO_CONFIG.SERVICES.HIRING },
      { '@type': 'Offer', name: SEO_CONFIG.SERVICES.BOOKS_STATIONERY },
      { '@type': 'Offer', name: SEO_CONFIG.SERVICES.SPORTS_CONNECT },
      { '@type': 'Offer', name: SEO_CONFIG.SERVICES.RIDES },
      { '@type': 'Offer', name: SEO_CONFIG.SERVICES.SAFETY_SOS },
    ],
  },
};

export const HYDERABAD_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  serviceType: 'Educational Services',
  name: 'Educational Services in Hyderabad - LocalAlly.in',
  provider: {
    '@type': 'EducationalOrganization',
    name: 'LocalAlly.in',
    url: SEO_CONFIG.SITE_URL,
  },
  areaServed: {
    '@type': 'City',
    name: 'Hyderabad',
  },
  url: `${SEO_CONFIG.SITE_URL}/hyderabad`,
  description:
    'Find comprehensive educational services in Hyderabad including home tutors, group tuitions, dance classes, music classes, child care services, and stay updated with school events, annual functions, and grand tests through LocalAlly.in.',
};

export const VIZAG_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  serviceType: 'Educational Services',
  name: 'Educational Services in Visakhapatnam - LocalAlly.in',
  provider: {
    '@type': 'EducationalOrganization',
    name: 'LocalAlly.in',
    url: SEO_CONFIG.SITE_URL,
  },
  areaServed: {
    '@type': 'City',
    name: 'Visakhapatnam',
  },
  url: `${SEO_CONFIG.SITE_URL}/visakhapatnam`,
  description:
    'Find comprehensive educational services in Visakhapatnam including home tutors, group tuitions, dance classes, music classes, child care services, and stay updated with school events, annual functions, and grand tests through LocalAlly.in.',
};

export const VIJAYAWADA_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  serviceType: 'Educational Services',
  name: 'Educational Services in Vijayawada - LocalAlly.in',
  provider: {
    '@type': 'EducationalOrganization',
    name: 'LocalAlly.in',
    url: SEO_CONFIG.SITE_URL,
  },
  areaServed: {
    '@type': 'City',
    name: 'Vijayawada',
  },
  url: `${SEO_CONFIG.SITE_URL}/vijayawada`,
  description:
    'Find comprehensive educational services in Vijayawada including home tutors, group tuitions, dance classes, music classes, child care services, and stay updated with school events, annual functions, and grand tests through LocalAlly.in.',
};

export const WARANGAL_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  serviceType: 'Educational Services',
  name: 'Educational Services in Warangal - LocalAlly.in',
  provider: {
    '@type': 'EducationalOrganization',
    name: 'LocalAlly.in',
    url: SEO_CONFIG.SITE_URL,
  },
  areaServed: {
    '@type': 'City',
    name: 'Warangal',
  },
  url: `${SEO_CONFIG.SITE_URL}/warangal`,
  description:
    'Find comprehensive educational services in Warangal including home tutors, group tuitions, dance classes, music classes, child care services, and stay updated with school events, annual functions, and grand tests through LocalAlly.in.',
};

export const SCHOOL_UPDATES_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'Event',
  name: 'School Updates & Events',
  description: 'Latest school updates, annual functions, grand tests, and educational events in Hyderabad',
  organizer: {
    '@type': 'EducationalOrganization',
    name: 'LocalAlly.in',
    url: SEO_CONFIG.SITE_URL,
  },
  location: {
    '@type': 'Place',
    name: 'Hyderabad',
    address: {
      '@type': 'PostalAddress',
      addressLocality: SEO_CONFIG.ADDRESS.LOCALITY,
      addressRegion: SEO_CONFIG.ADDRESS.REGION,
      addressCountry: SEO_CONFIG.ADDRESS.COUNTRY,
    },
  },
  url: `${SEO_CONFIG.SITE_URL}/school-updates`,
};

export const TUITIONS_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  serviceType: 'Tutoring Services',
  name: 'Home & Group Tuitions in Hyderabad - LocalAlly.in',
  provider: {
    '@type': 'EducationalOrganization',
    name: 'LocalAlly.in',
    url: SEO_CONFIG.SITE_URL,
  },
  areaServed: {
    '@type': 'City',
    name: 'Hyderabad',
  },
  url: `${SEO_CONFIG.SITE_URL}/tuitions`,
  description:
    'Find home tutors, group tuitions, and tuition centers in Hyderabad for all subjects and classes through LocalAlly.in.',
};

export const EXTRACURRICULAR_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  serviceType: 'Extracurricular Activities',
  name: 'Dance, Music & Art Classes in Hyderabad - LocalAlly.in',
  provider: {
    '@type': 'EducationalOrganization',
    name: 'LocalAlly.in',
    url: SEO_CONFIG.SITE_URL,
  },
  areaServed: {
    '@type': 'City',
    name: 'Hyderabad',
  },
  url: `${SEO_CONFIG.SITE_URL}/extracurricular`,
  description:
    'Discover dance classes, music classes, art classes, and other extracurricular activities in Hyderabad for all age groups through LocalAlly.in.',
};

export const EDUCATIONAL_HIRING_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'JobPosting',
  title: 'Educational Job Opportunities',
  description: 'Latest teaching and administrative job openings in schools and educational institutions',
  hiringOrganization: {
    '@type': 'EducationalOrganization',
    name: 'LocalAlly.in',
    url: SEO_CONFIG.SITE_URL,
  },
  jobLocation: {
    '@type': 'Place',
    name: 'Hyderabad',
    address: {
      '@type': 'PostalAddress',
      addressLocality: SEO_CONFIG.ADDRESS.LOCALITY,
      addressRegion: SEO_CONFIG.ADDRESS.REGION,
      addressCountry: SEO_CONFIG.ADDRESS.COUNTRY,
    },
  },
  url: `${SEO_CONFIG.SITE_URL}/educational-jobs`,
};

export const KUKATPALLY_SCHEMA = [
  {
    '@context': 'https://schema.org',
    '@type': 'Service',
    serviceType: 'Home tutoring',
    name: 'Home Tutors in Kukatpally - LocalAlly.in',
    provider: {
      '@type': 'LocalBusiness',
      name: 'LocalAlly.in',
      url: SEO_CONFIG.SITE_URL,
    },
    areaServed: {
      '@type': 'Place',
      name: 'Kukatpally, Hyderabad',
    },
    url: `${SEO_CONFIG.SITE_URL}/home-tutors-kukatpally`,
    description:
      'Browse trusted home tutors in Kukatpally for Maths, Science, English, and board exam support through LocalAlly.in.',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'How do I find a home tutor in Kukatpally on LocalAlly.in?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'You can browse tutor listings by subject, class level, and location, then contact a suitable tutor through LocalAlly.in.',
        },
      },
      {
        '@type': 'Question',
        name: 'Does LocalAlly.in list tutors near KPHB and nearby Kukatpally areas?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Yes, LocalAlly.in helps students discover tutors in Kukatpally, KPHB, and nearby Hyderabad neighborhoods.',
        },
      },
    ],
  },
];

export const SCHOLARSHIP_SCHEMA = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'N. Surya Narayana Memorial Scholarship 2026',
    url: `${SEO_CONFIG.SITE_URL}/scholarship`,
    description:
      'Free registration for the N. Surya Narayana Memorial Scholarship 2026 for Class 10 students. The exam has 30 questions, 30 marks, a 30 minute duration, and an 80 percent passing requirement.',
    isPartOf: {
      '@type': 'WebSite',
      name: 'LocalAlly.in',
      url: SEO_CONFIG.SITE_URL,
    },
    publisher: {
      '@type': 'EducationalOrganization',
      name: 'LocalAlly.in',
      url: SEO_CONFIG.SITE_URL,
      logo: `${SEO_CONFIG.SITE_URL}/logo.png`,
    },
    about: {
      '@type': 'Thing',
      name: 'Scholarship examination for Class 10 students',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Event',
    name: 'N. Surya Narayana Memorial Scholarship Examination 2026',
    description:
      'Online scholarship examination for registered Class 10 students. The exam is scheduled for 10:00 AM on Sunday, 26 July 2026, with 30 questions for 30 marks.',
    startDate: '2026-07-26T10:00:00+05:30',
    endDate: '2026-07-26T23:59:59+05:30',
    eventStatus: 'https://schema.org/EventScheduled',
    eventAttendanceMode: 'https://schema.org/OnlineEventAttendanceMode',
    isAccessibleForFree: true,
    location: {
      '@type': 'VirtualLocation',
      url: `${SEO_CONFIG.SITE_URL}/scholarship/exam`,
    },
    organizer: {
      '@type': 'EducationalOrganization',
      name: 'LocalAlly.in',
      url: SEO_CONFIG.SITE_URL,
    },
    offers: {
      '@type': 'Offer',
      url: `${SEO_CONFIG.SITE_URL}/scholarship`,
      price: '0',
      priceCurrency: 'INR',
      availability: 'https://schema.org/InStock',
      validFrom: '2026-06-22T00:00:00+05:30',
      validThrough: '2026-07-25T23:59:59+05:30',
    },
    audience: {
      '@type': 'EducationalAudience',
      educationalRole: 'student',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'Who can register for the N. Surya Narayana Memorial Scholarship 2026?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'The scholarship program is open for Class 10 students.',
        },
      },
      {
        '@type': 'Question',
        name: 'Is LocalAlly only for Class 10 students?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'No. This scholarship campaign is Class 10-specific, but LocalAlly supports tutor and coaching discovery for all classes, subjects, boards and competitive exams.',
        },
      },
      {
        '@type': 'Question',
        name: 'When are scholarship registrations open?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Registrations have been extended until 25 July 2026.',
        },
      },
      {
        '@type': 'Question',
        name: 'When does the scholarship exam open?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'The scholarship exam is scheduled for 10:00 AM on Sunday, 26 July 2026.',
        },
      },
      {
        '@type': 'Question',
        name: 'What is the scholarship exam format?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'The exam has 30 questions for 30 marks, with a 30 minute time limit. The passing requirement is 80 percent.',
        },
      },
      {
        '@type': 'Question',
        name: 'How can registered students access the exam?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Registered students can access the exam using the registered phone number and hall ticket number generated after registration.',
        },
      },
    ],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: SEO_CONFIG.SITE_URL,
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'Scholarship',
        item: `${SEO_CONFIG.SITE_URL}/scholarship`,
      },
    ],
  },
];

export const PAGE_SEO = {
  HOMEPAGE: {
    title: 'LocalAlly | Tutors, Books, Sports, Rides & Local Services Near You',
    description: 'Search LocalAlly.in for nearby tutors, coaching, books and stationery, local sports teams, tournaments, grounds, ride stands, autos, cabs, jobs, safety support and community updates across Andhra Pradesh and Telangana.',
    path: '/',
  },
  HYDERABAD: {
    title: 'Educational Services in Hyderabad | Tutors, Classes & School Updates | LocalAlly.in',
    description: 'Discover comprehensive educational services in Hyderabad including home tutors, group tuitions, tuition centers, dance classes, music classes, and latest school updates on LocalAlly.in.',
    path: '/hyderabad',
  },
  VIZAG: {
    title: 'Educational Services in Visakhapatnam | Tutors, Classes & School Updates | LocalAlly.in',
    description: 'Find comprehensive educational services in Visakhapatnam including home tutors, group tuitions, tuition centers, dance classes, music classes, and latest school updates on LocalAlly.in.',
    path: '/visakhapatnam',
  },
  VIJAYAWADA: {
    title: 'Educational Services in Vijayawada | Tutors, Classes & School Updates | LocalAlly.in',
    description: 'Discover comprehensive educational services in Vijayawada including home tutors, group tuitions, tuition centers, dance classes, music classes, and latest school updates on LocalAlly.in.',
    path: '/vijayawada',
  },
  WARANGAL: {
    title: 'Educational Services in Warangal | Tutors, Classes & School Updates | LocalAlly.in',
    description: 'Find comprehensive educational services in Warangal including home tutors, group tuitions, tuition centers, dance classes, music classes, and latest school updates on LocalAlly.in.',
    path: '/warangal',
  },
  SCHOOL_UPDATES: {
    title: 'School Updates & Events in Hyderabad | Annual Functions, Grand Tests | LocalAlly.in',
    description: 'Stay updated with latest school news, annual functions, grand tests, and educational events in Hyderabad. Get real-time updates from schools and educational institutions on LocalAlly.in.',
    path: '/school-updates',
  },
  TUITIONS: {
    title: 'Home & Group Tuitions in Hyderabad | All Subjects | LocalAlly.in',
    description: 'Find trusted home tutors, group tuitions, and tuition centers in Hyderabad for Maths, Science, English, and all subjects. Compare profiles and connect with qualified teachers on LocalAlly.in.',
    path: '/tuitions',
  },
  EXTRACURRICULAR: {
    title: 'Dance, Music & Art Classes in Hyderabad | Extracurricular Activities | LocalAlly.in',
    description: 'Discover dance classes, music classes, art classes, and extracurricular activities in Hyderabad for all age groups. Connect with experienced instructors and centers on LocalAlly.in.',
    path: '/extracurricular',
  },
  CHILD_CARE: {
    title: 'Child Care Services in Hyderabad | Babysitters & Caretakers | LocalAlly.in',
    description: 'Find reliable child care services, babysitters, and caretakers in Hyderabad. Verified and experienced caregivers for your children\'s safety and development on LocalAlly.in.',
    path: '/child-care',
  },
  EDUCATIONAL_JOBS: {
    title: 'Educational Jobs in Hyderabad | Teaching & School Staff | LocalAlly.in',
    description: 'Latest educational job opportunities in Hyderabad. Find teaching positions, administrative roles, and staff openings in schools and educational institutions on LocalAlly.in.',
    path: '/educational-jobs',
  },
  KUKATPALLY: {
    title: 'Educational Services in Kukatpally | Tutors, Classes & Updates | LocalAlly.in',
    description: 'Find home tutors, group tuitions, dance classes, music classes, and school updates in Kukatpally, Hyderabad. Complete educational platform for students and parents on LocalAlly.in.',
    path: '/kukatpally',
  },
  SCHOLARSHIP: {
    title: 'LocalAlly Scholarship Program for Class 10 Students | LocalAlly.in',
    description: 'Register free for the LocalAlly Class 10 scholarship program. Registrations are extended until 25 July 2026; exam is on 26 July 2026. LocalAlly also supports all classes and competitive exam coaching.',
    path: '/scholarship',
  },
  SCHOLARSHIP_EXAM: {
    title: 'Scholarship Exam Access | Hall Ticket Login | LocalAlly.in',
    description: 'Access the N. Surya Narayana Memorial Scholarship exam dashboard with the registered phone number and hall ticket number. The exam is scheduled for 10:00 AM on Sunday, 26 July 2026.',
    path: '/scholarship/exam',
  },
  SCHOLARSHIP_RESULTS: {
    title: 'Scholarship Results | N. Surya Narayana Memorial Scholarship | LocalAlly.in',
    description: 'View N. Surya Narayana Memorial Scholarship results, winner declaration status, and certificate access after the scholarship process is completed.',
    path: '/scholarship/results',
  },
};
